interface TableSkeletonProps {
    cols: number;
    rows?: number;
}

const WIDTHS = ["60%", "80%", "50%", "70%", "40%", "65%", "55%", "45%"];

export default function TableSkeleton({ cols, rows = 7 }: TableSkeletonProps) {
    return (
        <table className="dashboard-table" style={{ tableLayout: "fixed" }}>
            <tbody>
                {Array.from({ length: rows }).map((_, r) => (
                    <tr key={r}>
                        {Array.from({ length: cols }).map((_, c) => (
                            <td key={c}>
                                <span
                                    className="skeleton"
                                    style={{
                                        height: "14px",
                                        width: WIDTHS[(r + c) % WIDTHS.length],
                                    }}
                                />
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
